"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Season = void 0;
/**
 * Represents a season in the NFL.
 */
var Season;
(function (Season) {
    /**
     * The 2022 NFL season.
     */
    Season[Season["twentyTwentyTwo"] = 2022] = "twentyTwentyTwo";
    /**
     * The 2023 NFL season.
     */
    Season[Season["twentyTwentyThree"] = 2023] = "twentyTwentyThree";
    /**
     * The 2024 NFL season.
     */
    Season[Season["twentyTwentyFour"] = 2024] = "twentyTwentyFour";
    /**
     * The 2025 NFL season.
     */
    Season[Season["twentyTwentyFive"] = 2025] = "twentyTwentyFive";
})(Season || (exports.Season = Season = {}));
//# sourceMappingURL=season.js.map